<template>
<transition name="fade">
    <div class="loginReg" v-if="showBool">
        <div class="loginRegBox" v-show="!findPwd.open">
            <div class="loginRegTitle">
                <div class="btnBox">
                    <div :class="activeType==1?'loginchangeBtn active':'loginchangeBtn'" @click="tab(1)">登录</div>
                    <div :class="activeType==2?'regChangeBtn active':'regChangeBtn'" @click="tab(2)">注册</div>
                </div>
                <div v-show="showCloseBool" class="closeBtn" @click="showLoginReg"></div>
            </div>
            <div class="loginRegCon">
                <!-- 登录 -->
                <div class="loginRegConL" v-show="activeType==1">
                    <div class="loginRegConTitle">登录</div>
                    <div class="accountNum inputBox">
                        <input type="tel" maxlength="11" placeholder="输入手机号" v-model="login.phone">
                    </div>
                    <div class="password inputBox">
                        <input type="password" placeholder="输入密码" v-model="login.pwd" @keyup.enter="loginClick">
                    </div>
                    <!-- <div style="width: 220px; overflow: hidden">
                      <div class="password inputBox" style="width: 130px;float:left">
                          <input type="type" placeholder="输入认证码" v-model="login.code">
                          
                      </div>
                      <img src="" id='imgCode' alt="" style="height: 32px; width: 80px; float: right; cursor: pointer;" title="点击更换验证码" @click="getIdentifyingCode()">
                    </div> -->
                    <div class="autoLogin">
                        <span :class="auto_login?'changeIcon active':'changeIcon'" @click="autoLogin"> </span>
                        一周内自动登录
                    </div>
                    <div class="loginBtn loginRegBtn" @click="loginClick">登录</div>
                    <div class="findPassWord" @click="showFindPwd(true)">找回密码</div>
                </div>
                <!-- 注册 -->
                <div class="loginRegConL" v-show="activeType==2">
                    <div class="loginRegConTitle">注册</div>
                    <div class="accountNum inputBox">
                        <input type="tel" maxlength="11" placeholder="输入手机号" v-model="reg.phone">
                    </div>
                    <div class="password inputBox halfBox">
                        <input type="text" placeholder="输入验证码" v-model="reg.code">
                        <span :class="codeMsg=='获取验证码'?'purpleBtn':'garyBtn'" @click="getCode">{{codeMsg}}</span>
                    </div>
                    <div class="password inputBox">
                        <input type="password" placeholder="输入8-16位密码" v-model="reg.pwd">
                    </div>
                    <div class="password inputBox">
                        <input type="password" placeholder="再次输入密码" v-model="reg.repwd">
                    </div>
                    <div class="loginBtn loginRegBtn regbutton" :class="agree_protocol?'':'disable'" @click="register">立即注册</div>
                    <div class="autoLogin">
                      <span :class="agree_protocol?'changeIcon active':'changeIcon'" @click="onAccept"> </span>
                      同意<a target="_blank" style="color:#7c46e8" href="/provision">《注册协议》</a> 
                      和<a target="_blank" style="color:#7c46e8" href="/policy">《隐私政策》</a> 
                    </div>
                </div>
                <div class="line"></div>
                <div class="loginRegConR">
                    <div class="loginRegConTitle">第三方直接登录</div>
                    <div class="btnList">
                        <div class="loginThreeBtn" @click="toLogin('qq',1)">QQ账号登录</div>
                        <!-- <div class="loginThreeBtn" @click="toLogin('wechat',2)">微信登录</div>
                        <div class="loginThreeBtn" @click="toLogin('weibo',3)">微博账号登录</div> -->
                        <div class="loginThreeBtn" @click="toLogin('show',4)">平台账号登录</div>
                    </div>
                    <div class="useThreeLoginExplain">使用即为同意 <a target="_blank" style="color:#7c46e8" href="/provision">《注册协议》</a> 和<a target="_blank" style="color:#7c46e8" href="/policy">《隐私政策》</a> </div>
                </div>
            </div>
        </div>
        <div class="findPwdBox" v-show="findPwd.open">
          <div class="title">找回密码</div>
          <div class='inputBoxR'>
            <div class='contentTitle'>手机号：</div>
            <div class="inputBox">
              <input type="text" placeholder="请输入手机号码" maxlength="11" v-model="findPwd.phone">
            </div>
          </div>
          <div class='inputBoxR'>
            <div class='contentTitle'>验证码：</div>
            <div class="inputBox">
              <input type="text" placeholder="请输入验证码" v-model="findPwd.code">
              <span :class="findPwd.codeMsg=='获取验证码'?'purpleBtn':'garyBtn'" @click="pwdCode">{{findPwd.codeMsg}}</span>
            </div>
          </div>
          <div class='inputBoxR'>
            <div class='contentTitle'>新密码：</div>
            <div class="inputBox">
              <input type="password" placeholder="请输入密码" v-model="findPwd.pwd">
            </div>
          </div>
          <div class='inputBoxR confirmPWd'>
            <div class='contentTitle'>确认密码：</div>
            <div class="inputBox">
              <input type="password" placeholder="请再次输入密码" v-model="findPwd.repwd">
            </div>
          </div>
          <div class="buttonBox">
            <button class="purpleBtn" @click="findPwdClick">确认</button>
            <button class="purpleBtn" @click="showFindPwd(false)">取消</button>
          </div>
        </div>
    </div>
</transition>
</template>
<script>
  var timer=null;
    import {
      RSAAPP,
      RSAKeyPair,
      encryptedString,
      decryptedString
    } from '@/js/utils/RSA/rsa.js';
    import {
        setMaxDigits
    } from '@/js/utils/RSA/BigInt.js';
    import jsonpAdapter from 'axios-jsonp';
    var timer;
    export default {
        name:"loginReg",
        data(){
            return{
              login:{phone:'',pwd:'', code: ''},
              reg:{phone:'',code:'',pwd:'',repwd:''},
              auto_login:true,
              codeMsg:"获取验证码",
              findPwd:{
                codeMsg:'获取验证码',
                phone:'',
                code:'',
                pwd:'',
                repwd:'',
                open:false
              },
              agree_protocol:true,
              codeImg: ''
            }
        },
        watch: {
          showBool () {
            if (this.showBool) {
              let time = setInterval(() => {
                let img = document.getElementById("imgCode")
                if (img) {
                  this.getIdentifyingCode()
                  clearInterval(time)
                }
              }, 100);
            }
          }
        },
        computed: {
            showBool(){
                return this.$store.state.loginReg.showBool
            },
            activeType(){
              return this.$store.state.loginReg.activeType
            },
            showCloseBool(){
              return this.$store.state.loginReg.bShowClose
            }
        },
        methods: {
            getIdentifyingCode () {
              let cId = localStorage.getItem('cid')
              let img = document.getElementById("imgCode")
              if (!cId) {
                this.axios({
                  url: 'https://api.fengbolive.com/userinfo/captcha/init.html',
                  adapter: jsonpAdapter,
                }).then(res => {
                  if(res.data.code == 0) {
                    localStorage.setItem('cid', res.data.data.captcha_id)
                    // this.codeImg = 'https://api.fengbolive.com' + res.data.data.url
                    img.src = 'https://api.fengbolive.com/userinfo/captcha/image.html?captcha_id=' + res.data.data.captcha_id
                  }
                })
              } else {
                img.src = 'https://api.fengbolive.com/userinfo/captcha/image.html?captcha_id=' + cId + '&' + Math.random()
              }
            },
            autoLogin(){
              this.auto_login=!this.auto_login;
            },
            onAccept(){
              this.agree_protocol=!this.agree_protocol;
            },
            showLoginReg(index){
					      this.$store.dispatch('upDataLoginRegCloseBtnShowBool',true);
                this.$store.dispatch('upDataLoginRegShowBool', 1);
            },
            showFindPwd(bool){
              this.findPwd.open=bool;
            },
            tab(index){
              this.$store.dispatch('loginBoxCardTab',index);
            },
            pwdCode(){
              if(this.findPwd.codeMsg!='获取验证码'){
                return
              }
              if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.findPwd.phone)){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请输入正确的手机号码'});
                return
              }
              var nowtimeStamp=new Date().getTime();
              var data = {
                  mobile: this.findPwd.phone,
                  type: 3,
                  time: nowtimeStamp,
                  sign: this.$md5(this.findPwd.phone + nowtimeStamp + '2016sinashow0919time1900')
              }
              this.axios({
                method:'post',
                url:location.protocol+'//api.fengbolive.com/userinfo/identityphone/newindex.html',
                data:this.$common.changeobj(data)
              }).then(res=>{
                res=res.data;
                if(res.code==1){
                  var num=60;
                  this.findPwd.codeMsg=num+'秒';
                  var that=this;
                  timer=setInterval(function(){
                    num--;
                    if(num<=0){
                      that.findPwd.codeMsg='获取验证码';
                      clearInterval(timer);
                    }else{
                      that.findPwd.codeMsg=num+'秒';
                    }
                  },1000)
                }else{
                  this.$store.dispatch('upDataWindowBoxShowBool',{msg:res.msg});
                  return
                }
              })
            },
            getCode(){
              if(this.codeMsg!='获取验证码'){
                return
              }
              if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.reg.phone)){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请输入正确的手机号码'});
                return
              }
              var time = parseInt(Date.now() / 1000)
              var data = {
                  mobile: this.reg.phone,
                  type: 1,
                  time: time,
                  sign: this.$md5(this.reg.phone + time + '2016sinashow0919time1900'),
              }
              this.axios({
                method:'post',
                url:location.protocol+"//api.fengbolive.com/userinfo/identityphone/newindex.html",
                data:this.$common.changeobj(data)
              }).then(res=>{
                res=res.data;
                if(res.code===1){
                  var num=60;
                  this.codeMsg=num+'秒';
                  var that=this;
                  timer=setInterval(function(){
                    num--;
                    if(num<=0){
                      that.codeMsg='获取验证码';
                      clearInterval(timer);
                    }else{
                      that.codeMsg=num+'秒';
                    }
                  },1000)
                }else{
                  this.$store.dispatch('upDataWindowBoxShowBool',{msg:'该手机号已注册'});
                  return
                }
              })
            },
            findPwdClick(){
              if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.findPwd.phone)){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请输入正确的手机号码'});
                return
              }
              if(!this.findPwd.phone||!this.findPwd.code||!this.findPwd.pwd||!this.findPwd.repwd){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请填写完整的信息'});
                return
              }
              if(this.findPwd.pwd!=this.findPwd.repwd){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'两次密码不一致'});
                return
              }
              if(this.findPwd.pwd.length<8||this.findPwd.pwd.length>16){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请输入8-16位密码'});
                return
              }
              var nowtimeStamp = new Date().getTime();
              var data = {
                  mobile: this.findPwd.phone,
                  type: 3,
                  code: this.findPwd.code,
                  password: this.findPwd.pwd,
                  reg_mac: localStorage.getItem('mac'),
                  pid:this.$store.state.loginUserInfo.pid
              }
              this.axios({
                method:'post',
                url:location.protocol+"//api.fengbolive.com/userinfo/editinfo/repass.html",
                data:this.$common.changeobj(data)
              }).then(res=>{
                res=res.data;
                if(res.code==1){
                  this.$store.dispatch('upDataWindowBoxShowBool',{msg:'修改成功'});
                  this.showFindPwd(false);
                  return
                }else{
                  this.$store.dispatch('upDataWindowBoxShowBool',{msg:res.msg});
                  return
                }
              })
            },
            register(){
              if (!this.agree_protocol) {
                return;
              }
              if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.reg.phone)){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请输入正确的手机号码'});
                return
              }
              if(!this.reg.phone||!this.reg.code||!this.reg.pwd||!this.reg.repwd){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请填写完整的信息'});
                return
              }
              if(this.reg.pwd!=this.reg.repwd){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'两次密码不一致'});
                return
              }
              if(this.reg.pwd.length<8||this.reg.pwd.length>16){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请输入8-16位密码'});
                return
              }
              var nowtimeStamp = new Date().getTime();
              var reg_mac = this.$md5(nowtimeStamp + 'wutamobileWEB');
              var data = {
                  mobile: this.reg.phone,
                  code: this.reg.code,
                  password: this.reg.pwd,
                  typename: 'pc',
                  version: '1.0.0',
                  reg_mac: reg_mac,
                  qid: this.$store.state.loginUserInfo.qid,
                  sqid: this.$store.state.loginUserInfo.sqid,
                  pid: this.$store.state.loginUserInfo.pid,
                  phone_version: '8.0.0',
                  channeltype: '2',
                  equipment: 'H5'
              }
              this.axios({
                method:'post',
                url:location.protocol+"//api.fengbolive.com/userinfo/reg.html",
                data:this.$common.changeobj(data)
              }).then(res=>{
                res=res.data;
                  if (res.code === 1) {
                      this.$store.dispatch('upDataWindowBoxShowBool',{msg:'注册成功'});
                      this.tab(1);
                  } else {
                      this.$store.dispatch('upDataWindowBoxShowBool',{msg:res.msg});
                  }
              })
            },
            loginClick(){
              if(!/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.login.phone)){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请输入正确的手机号码'});
                return
              }
              if(!this.login.phone||!this.login.pwd){
                this.$store.dispatch('upDataWindowBoxShowBool',{msg:'请填写完整的信息'});
                return
              }
              var nowtimeStamp = new Date().getTime();
              //mac地址
              var reg_mac = this.$md5(nowtimeStamp + 'wutamobileWEB');
              var data = {
                  mobile: Number(this.login.phone),
                  pwd: this.login.pwd,
                  m: this.$md5(this.login.phone+ '' + this.login.pwd + 'qweqe123123123asdfdasfajodkfao2342340'),
                  phoneway: 'pc',
                  reg_mac: reg_mac,
                  version: '1.0.0',
                  qid: this.$store.state.loginUserInfo.qid,
                  sqid: this.$store.state.loginUserInfo.sqid,
                  p_id: this.$store.state.loginUserInfo.pid,
                  captcha_id: localStorage.getItem('cid'),
                  captcha: this.login.code
              }
              let that = this;
              this.axios({
                method: 'post',
                url: location.protocol+'//api.fengbolive.com/userinfo/loginphone/login.html',
                data: this.$common.changeobj(data)
              }).then(res=>{
                res=res.data;
                if(res.code==1){
                  localStorage.setItem('mac',reg_mac);
                  that.showLoginReg();
                  if(that.auto_login&&!that.$common.getCookie('userInfo')){
                    that.$common.setCookie('userInfo',JSON.stringify(res.data),7);
                  }
                  /*var now=new Date();
                  var sbt=parseInt(now.getTime()/1000);
                  var set=parseInt(now.setDate(now.getDate()+7)/1000);
                  var logindata={
                    'suid':res.data.info.user_id,
                    'snick':res.data.info.nick_nm,
                    'sbt':sbt,
                    'set':set
                  };
                  var md5data=this.$md5(sbt+''+set+logindata.suid+decodeURIComponent(logindata.snick)+'v0');*/
                  /*that.$common.cjcookie('FENGBO','es='+md5data+'&ev=v0',7,'/','.fengbolive.com');
                  that.$common.cjcookie('FENGBOZHIBO',this.$common.changeobj(logindata),7,'/','.fengbolive.com');*/
                  //that.$common.cjcookie('FENGBO','es='+md5data+'&ev=v0',7,'/','.live.sinashow.com');
                  //that.$common.cjcookie('FENGBOZHIBO',this.$common.changeobj(logindata),7,'/','.live.sinashow.com');
                  that.$store.dispatch('uiState_update_login_user_info',res.data);
                  that.getLoginLevel(res.data.info.user_id, res.data.token);
                  that.getExtraInfo(res.data.info.user_id, res.data.token);
                  localStorage.setItem('loginType',5);
                }else{
                  that.$store.dispatch('upDataWindowBoxShowBool',{msg:res.msg});
                }
              })
            },
            toLogin(type,index){
              if(type=='show'){
                var url='//client.yiyol.cn/frontend/web/index.php?r=login/';
              }else{
                var url='//client.yiyol.cn/frontend/web/index.php?r=login/';
              }
              localStorage.setItem('loginType',index);
              setMaxDigits(256);
              var RSAKey = new RSAKeyPair("10001", "", "00B11790EB15A8091706948D3CD4B10604359C1DE8BEFB3862EBB1E15D2BEEADB3", 256);
              var sign = window.btoa(encryptedString(RSAKey,this.$store.state.loginUserInfo.pid+','+this.$store.state.loginUserInfo.version+','+this.$store.state.loginUserInfo.phonetype , RSAAPP.NoPadding, RSAAPP.RawEncoding));
              var href = location.protocol+url+type+'&back_url='+encodeURIComponent(location.href.trim().replace(/#/g,''))+'&mac='+localStorage.getItem('mac')+'&qid='+this.$store.state.loginUserInfo.qid+'&phone_version='+this.$store.state.loginUserInfo.version+'&m='+this.$md5(this.$store.state.loginUserInfo.pid+this.$store.state.loginUserInfo.version+localStorage.getItem('mac')+this.$store.state.loginUserInfo.qid+this.$store.state.loginUserInfo.version+sign+'Ecw12-23Ebc-E98fc-ec123m-5ESCD')+'&sign='+encodeURIComponent(sign);
              location.href=href;
            },
            getLoginLevel(uid, token){
              //let nowtimeStamp = new Date().getTime();
              //"user_id=%I64d&token=%s&reg_mac=%s&uid=%I64d";
              //let sign = this.getSign( this.userInfo.user_id, this.$store.state.loginUserInfo.version, nowtimeStamp, this.userToken, iPage, localStorage.getItem('mac'), 'get_hot_list_h5');
              var parData = {
                user_id:uid,
                token: token,
                reg_mac: localStorage.getItem('mac'),
                uid:uid,
              };
              let that = this;
              this.axios({
                url:"https://api.fengbolive.com/userinfo/getuserinfo/getlevle.html?" + this.$common.changeobj(parData)
              }).then(res=>{
                let data = res.data;
                if (data.code >= 0 || data.ret >= 0) {
                    that.$store.dispatch('upDateLoginUserLevel',data.data);
                    sessionStorage.setItem('userLevel',JSON.stringify(data.data));
                }
              }).catch();
            },
            getExtraInfo(uid, token){
              let parData = {
                user_id:uid,
                token: token,
                reg_mac: localStorage.getItem('mac'),
                uid:uid,
              };
              let that = this;
              this.axios({
                url:"https://api.fengbolive.com/userinfo/getinfo.html?" + this.$common.changeobj(parData),
                adapter: jsonpAdapter,
                callbackParamName: 'callback', // optional, 'callback' by default
              }).then(res=>{
                let data = res.data;
                if (data.code >= 0 || data.ret >= 0) {
                    that.$store.dispatch('upDateUserExtraInfo',data.data);
                    sessionStorage.setItem('userExtraInfo',JSON.stringify(data.data));
                }
              }).catch();
            }
        },
        mounted(){
          
        }
    }
</script>

<style scoped>
.loginReg{ position: fixed; width: 100%; height: 100%; z-index: 100; background: rgba(0, 0, 0, 0.5);top: 0;left: 0;}
.loginRegBox{ width: 526px; position: absolute; left: 50%; top: 50%; transform: translate(-50%,-50%); border-radius: 8px; overflow: hidden;}
.loginRegTitle{
    display: flex; justify-content: flex-start;line-height: 65px; align-items: center; padding: 0 30px; box-sizing: border-box;
  background-image: linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  background-image: -moz-linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  background-image: -webkit-linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  background-image: -ms-linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  height: 46px;
}
.loginchangeBtn{ border-bottom: 2px solid transparent; color: #fff; font-size: 14px; margin-right: 63px; line-height: 25px;cursor:pointer;}
.regChangeBtn{ border-bottom: 2px solid transparent; color: #fff; font-size: 14px; line-height: 25px;cursor:pointer;}
.btnBox{ display: flex; justify-content: flex-start; flex: 1}
.loginchangeBtn.active,.regChangeBtn.active{ border-color: #fff;}
.closeBtn{ width: 18px; height: 18px; background: url(~@/assets/images/closeIcon.png);cursor:pointer}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.loginRegCon{ background: #fff; display: flex; justify-content: center; align-items: center}
.loginRegConL,.loginRegConR{ margin-left: 13px; position: relative; height: 280px; width: 49%}
.loginRegConTitle{ font-size: 12px; color: #999999; margin-bottom: 5px; line-height: 20px;}
.inputBox{ border: 1px solid #ccc; height: 37px; color: #ababab; border-radius: 8px; padding: 0 10px;margin-bottom: 12px; box-sizing: border-box; width: 220px;position:relative}
.inputBox input{ height:32px; line-height: 35px; font-size: 12px; width: 100%;}
.inputBox.halfBox input{ height:35px; line-height: 35px; font-size: 12px; width: 110px}
.inputBox span{width:85px;height:28px;position:absolute;z-index:5;text-align:center;top:3px;right:7px;font-size:12px;border-radius:4px;line-height:29px;cursor:pointer}
.inputBox .garyBtn{background:#333333;color:#fff;cursor:pointer}
.autoLogin{ color: #ababab; font-size: 12px; line-height: 14px; }
.autoLogin .changeIcon{ display:inline-block; width: 13px; height: 13px; background: url(~@/assets/images/autoCheck.png) no-repeat;background-size: 13px 13px; vertical-align: middle; margin: 0px 3px 0 0;}
.autoLogin .changeIcon.active{ background: url(~@/assets/images/autoUncheck.png) no-repeat;background-size: 13px 13px;}
.loginRegBtn {
  border-radius: 10px;
  background-image: linear-gradient( 150deg, rgb(142,45,226) 8%, rgb(74,0,224) 100%);
  background-image: -moz-linear-gradient( -150deg, rgb(142,45,226) 8%, rgb(74,0,224) 100%);
  background-image: -webkit-linear-gradient( -150deg, rgb(142,45,226) 8%, rgb(74,0,224) 100%);
  background-image: -ms-linear-gradient( -150deg, rgb(142,45,226) 8%, rgb(74,0,224) 100%);
  height: 35px;
  text-align: center;
  line-height: 35px;
  color: #fff;
  display: inline-block;
  width: 84px;
  cursor: pointer;
  margin-top: 13px;
  font-size: 14px;
}
.loginRegBtn.regbutton{ 
  margin-top: 0px;
  margin-bottom: 8px;
}
.regbutton.disable{ 
  background-image: linear-gradient( 150deg, #cccccc 8%, #cccccc 100%);
  background-image: -moz-linear-gradient( -150deg, #cccccc 8%, #cccccc 100%);
  background-image: -webkit-linear-gradient( -150deg, #cccccc 8%, #cccccc 100%);
  background-image: -ms-linear-gradient( -150deg, #cccccc 8%, #cccccc 100%);
  cursor: default;
}

.findPassWord{ position: absolute; bottom:5px; left: 0px; color: #ababab; cursor: pointer; font-size: 12px}
.line{ width: 2px; height: 276px; background: #ccc; margin-top: 9px; margin-bottom: 9px; }
.btnList{display: flex; justify-content: space-around; flex-direction: column;}
.loginThreeBtn{ width: 170px; height: 35px; background: url(~@/assets/images/threeLoginBtnBg.png) no-repeat; background-size:170px 35px ;line-height: 35px; text-align: center; font-size: 12px; color: #7e3aef; margin: 0  auto 14px;cursor:pointer}
.useThreeLoginExplain{ position: absolute; text-align: center; bottom: 5px; width: 100%; left: 50%; transform: translateX(-50%); color: #ababab;font-size: 12px;}
.findPwdBox{
  width:400px;
  height:322px;
  background: #fff;
  border-radius: 10px;
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  margin:auto;
}
.findPwdBox .title{
  border-radius: 10px 10px 0px 0px;
  display: flex; justify-content: flex-start;line-height: 65px; align-items: center; padding: 0 15px; box-sizing: border-box;
  background-image: linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  background-image: -moz-linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  background-image: -webkit-linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  background-image: -ms-linear-gradient( 170deg, rgb(142,45,226) 40%, rgb(74,0,224) 120%);
  text-align: left;
  height:45px;
  line-height: 50px;
  font-size:14px;
  color: #fff;
}
.findPwdBox .inputBoxR{
  margin:15px auto;
  justify-content:center;
  display: flex;
  height:37px;
}
.findPwdBox .contentTitle{
  font-size: 14px;
  line-height: 35px;
  color: #cccccc;
}
.findPwdBox .inputBox{
  margin:0px;
  display: flex;
}
.findPwdBox .confirmPWd .inputBox{
  width:206px;
}
.findPwdBox .buttonBox{
  width:100%;
  text-align: center;
}
.findPwdBox .buttonBox button{
  margin:5px 15px 0px 15px;
  width:120px;
  height:36px;
  border-radius: 4px;
  font-size:14px;
}
</style>
